import {ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TranslateService} from '@atumverse/core-decorators';
import {
  AlertService,
  ConfigService,
  DateService,
  EventsService,
  FinfraMenuService,
  OfflineStatusService,
  SessionService
} from '@atumverse/core-services';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {HttpResponse} from '@angular/common/http';
import {FinfraIamEntitlementApi} from '@atumverse/iam-app';
import {
  DashboardFilters,
  FinfraDashboardContainerService,
  FinfraFilterService
} from '@atumverse/app-core-widgets';


@Component({
  selector: 'finfra-dashboard-container',
  templateUrl: './finfra-dashboard-container.component.html',
  styleUrls: ['./finfra-dashboard-container.component.scss'],
})
export class FinfraDashboardContainerComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined;
  public functionId: string | undefined;

  public translateLabelsName = 'finfra-dashboard';
  public translateFolder = 'labels/dashboard/';
  public translateLabelsLoaded = false;

  public translateFunctionsFolder = 'labels/screens/';

  public selectedFunctionIdControl: FormControl = new FormControl(null);
  public functionGroupControl: FormControl = new FormControl('*');

  public startTransactionDialogRef: MatDialogRef<any> | undefined;
  @ViewChild('startTransactionTemplate') startTransactionDialog: TemplateRef<any> | undefined;

  public chartCollapse = false;
  public panelLoaded = false;
  public loadingFunctionLabels = 0;
  public currUser: any;
  public selectedStartTransactionTabIndex = 0;

  constructor(
    private translateService: TranslateService,
    public changeDetectorRef: ChangeDetectorRef,
    public finfraMenuService: FinfraMenuService,
    public finfraDashboardService: FinfraDashboardContainerService,
    public offlineStatusService: OfflineStatusService,
    private eventsService: EventsService,
    public configService: ConfigService,
    private sessionService: SessionService,
    private dialog: MatDialog,
    public dateService: DateService,
    private alertService: AlertService,
    private finfraIamEntitlementApi: FinfraIamEntitlementApi,
    public finfraDashboardContainerService: FinfraDashboardContainerService,
    public finfraFilterService: FinfraFilterService
  ) {

  }

  ngOnInit(): void {
    this.currUser = this.sessionService.getUser();
    this.userPreferenceInit();
    this.functionId = this.finfraMenuService.currentMenu?.id;
    this.applicationId = this.finfraMenuService.currentApplicationId;
    this.translateService.loadLabels(this, this.labelsLoaded.bind(this));
    this.onResize();
  }

  ngOnDestroy(): void {
    this.finfraDashboardService.destroyFunction();
    this.finfraFilterService.destroy();
  }
  
  public labelsLoaded(): void {
    if (!this.functionId) {
      this.functionId = this.finfraMenuService.currentMenu?.id;
      this.applicationId = this.finfraMenuService.currentApplicationId;

      if (!this.functionId) {
        return;
      }
    }

    this.finfraDashboardService.init();
    this.finfraDashboardService.initFunction(this.functionId);


    this.finfraDashboardService.filters.push({
      fq: 'applicationId:' + this.applicationId,
      label: 'applicationId',
      closable: false,
      show: true,
      tooltip: this.applicationId,
    });

	const transactionReferenceNumber: any = this.sessionService.getSessionData('transactionReferenceNumber');
    if (transactionReferenceNumber) {
      this.finfraDashboardContainerService.searchDataControl.patchValue(transactionReferenceNumber);
      this.finfraDashboardContainerService.searchByControl.patchValue('transactionReferenceNumber');

      this.sessionService.clearSessionData('transactionReferenceNumber');
    }
    // Set the initial sort by date
    this.finfraDashboardService.groupByData.forEach(
      (value : any, key : any) => {
        value.sortBy = [];
        value.sortBy.push('currentStageArrivalDate desc');
      }
    );
    this.panelLoaded = true;
  }

  public async collapseChart(): Promise<void> {
    this.chartCollapse = !this.chartCollapse;
    this.currUser = this.sessionService.getUser();
    const result: any = await this.finfraDashboardContainerService.userChartPreference(this.currUser, this.chartCollapse);

    if (result && result.status === 200 && result instanceof HttpResponse) {
      this.alertService.debug('Saved user menu preference');
    } else {
      this.alertService.showErrorMessage(result);
    }
  }

  public async userPreferenceInit(): Promise<void> {
    if (!this.currUser || !this.currUser.userId) {
      return;
    }

    const result = await this.finfraIamEntitlementApi.getUserPreferences('finfra-user-preference', this.currUser.userId).catch(
      error => {
        this.alertService.showErrorMessage(error);
        return undefined;
      }
    );

    if (result && result.status === 200 && result instanceof HttpResponse) {
      if (result.body.responseStatus === 'SUCCESS') {

        if (Array.isArray(result?.body.finData)) {

          result?.body.finData.forEach(
            (pref: { key: string; value: string; }) => {
              if (pref.key === 'showChartOnLaunch') {
                if (pref.value === 'true') {
                  this.chartCollapse = true;
                } else {
                  this.chartCollapse = false;
                }
              }
            }
          );
        }
      }
    }
  }

  
  public async removeFilter(filter: DashboardFilters): Promise<void> {
    for (let idx = 0; idx < this.finfraDashboardService.filters.length; idx++) {
      if (filter.label === this.finfraDashboardService.filters[idx].label) {
        this.finfraDashboardService.filters.splice(idx, 1);
        break;
      }
    }

    this.finfraDashboardService.filterRemoved();
    await this.finfraDashboardService.fetchDataForPanels();
    this.changeDetectorRef.detectChanges();
  }


  @HostListener('window:resize', [])
  public onResize(): void {
    const width = window.innerWidth;
    this.finfraDashboardService.cardLayout = width < 1024;
  }
}
